/** Must stay aligned with PROPOSAL_INVOICE_GST_RATE. */
const GST_INCLUSIVE_DIVISOR = 1.09;

export const PROPOSAL_AGREED_PRICE_BASES = ["before_gst", "gst_inclusive"] as const;
export type ProposalAgreedPriceBasis = (typeof PROPOSAL_AGREED_PRICE_BASES)[number];

function roundMoney(n: number): number {
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

export function isProposalAgreedPriceBasis(value: unknown): value is ProposalAgreedPriceBasis {
  return value === "before_gst" || value === "gst_inclusive";
}

/** Historical records with no basis remain Before GST. Never infer from round amounts. */
export function resolveAgreedPriceBasis(retail: { agreedPriceBasis?: unknown } | null | undefined): ProposalAgreedPriceBasis {
  return retail?.agreedPriceBasis === "gst_inclusive" ? "gst_inclusive" : "before_gst";
}

export function isGstInclusiveFinalAgreedPrice(input: {
  discountMethod?: unknown;
  agreedPriceBasis?: unknown;
  invoiceGstEnabled?: boolean | null;
}): boolean {
  return (
    input.invoiceGstEnabled === true &&
    input.discountMethod === "final_agreed_price" &&
    input.agreedPriceBasis === "gst_inclusive"
  );
}

/** Canonical ex-GST commercial amount derived from a GST-inclusive nett price. */
export function canonicalExGstFromGstInclusiveNett(nettInclusive: number): number {
  return roundMoney(Math.max(0, nettInclusive) / GST_INCLUSIVE_DIVISOR);
}

export function gstInclusivePayableComponents(nettInclusive: number): {
  enteredNettInclusive: number;
  canonicalExGst: number;
  gstAmount: number;
  finalAmountPayable: number;
} {
  const enteredNettInclusive = roundMoney(Math.max(0, nettInclusive));
  const canonicalExGst = canonicalExGstFromGstInclusiveNett(enteredNettInclusive);
  const gstAmount = roundMoney(enteredNettInclusive - canonicalExGst);
  return {
    enteredNettInclusive,
    canonicalExGst,
    gstAmount,
    finalAmountPayable: enteredNettInclusive,
  };
}
